import { IAction } from '@ws/shared/types';
import { put, takeEvery } from 'typed-redux-saga';

import {
  ICountForNoteAction,
  ICountForProjectAction,
  STATS_COUNT_FOR_NOTE,
  STATS_COUNT_FOR_PROJECT,
  TStatsCounter,
} from './stats.types';
import { getTextLengthFromHtml } from '../../utils/stats/getTextLengthFromHtml';
import { updateALLCounters } from './stats.actions';

// Effect for counting words in a specific note (without implementation as per requirements)
function* countForNoteUpdateEffect(action: IAction<ICountForNoteAction>) {
  // Implementation would go here
  console.log('countForNoteUpdateEffect called with:', action);
  yield undefined;
}

// Effect for counting words in all notes of a project (without implementation as per requirements)
function* countForProjectNotesEffect(action: IAction<ICountForProjectAction>) {
  // Implementation would go here
  console.log('countForProjectNotesEffect called with:', action);

  if (!action.payload) {
    return;
  }

  const dict: Record<string, TStatsCounter> = {};

  action.payload.list.forEach((note) => {
    dict[note.id] = getTextLengthFromHtml(note.content);
  });

  yield* put(updateALLCounters({ dict }));
}

export function* statsWatch() {
  yield* takeEvery(STATS_COUNT_FOR_NOTE, countForNoteUpdateEffect);
  yield* takeEvery(STATS_COUNT_FOR_PROJECT, countForProjectNotesEffect);
}
